export default {
    deliver: 'تسليم',
    receive: 'استلام',
    'remaining-samples': 'العينات المتبقية',
}